import { title } from "assets/jss/material-kit-react.js";

const productStyle = {
  section: {
    top: "30%",
    padding: "70px 0",
    textAlign: "center",
    marginBottom: "4rem",
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
  },
  description: {
    color: "#999",
  },
};

export default productStyle;
